import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBPo4AATAQwpjVKZlfs6oMkdFvHYiA_kqI',
  authDomain: 'welnesscraft.firebaseapp.com',
  projectId: 'welnesscraft',
  storageBucket: 'welnesscraft.firebasestorage.app',
  messagingSenderId: '164919350564',
  appId: '1:164919350564:web:c8a2d3e16874811f448fb1',
  measurementId: 'G-8TX6GGWV2Y',
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
